import React from "react";
import { YMAPS_ERROR_NO_KEY } from "../shared/ymaps";

/**
 * Показывает состояние загрузки Яндекс.Карт вместо самой карты.
 *
 * Плейсхолдер держит ту же высоту, что и карта, — иначе при переключении
 * на вкладку «Карта» страница дёргается.
 *
 * Props:
 *   status   — 'loading' | 'ready' | 'error' из useYmaps()
 *   error    — Error | null
 *   height   — CSS-высота
 *   children — карта, рендерится только при status === 'ready'
 */
export default function YMapsGate({ status, error, height, children }) {
  if (status === "ready") return children;

  const message =
    status === "loading"
      ? "Загрузка карты…"
      : error && error.message === YMAPS_ERROR_NO_KEY
        ? "Карта недоступна: не задан ключ Яндекс.Карт"
        : "Не удалось загрузить Яндекс.Карты";

  return (
    <div className="ymaps-gate" style={{ height }}>
      {message}
    </div>
  );
}
